module.exports = __webpack_public_path__ + "static/img/Niu-niu_open4.3a669bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/Niu-niu_open4.jpg
// module id = Xe6N
// module chunks = 0